import { Typography, Link, Box, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import GitHubIcon from '@mui/icons-material/GitHub';
import BookIcon from '@mui/icons-material/Book';

import React from 'react';

const FooterRoot = styled('div')(({ theme }) => ({
  padding: '20px',
  background: theme.palette.common.black,
  color: theme.palette.common.white,
}));

const Footer: React.FC = () => {
  return (
    <FooterRoot>
      <Typography variant="body2" paragraph align="center">
        {'made by sma2lbao | Copyright © '}
        <Link
          color="inherit"
          href="https://sma2lbao.github.io/"
          target="_blank"
        >
          sma2lbao.github.io
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
      <Box
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <IconButton
          color="inherit"
          LinkComponent={Link}
          target="_blank"
          href="https://github.com/sma2lbao/"
        >
          <GitHubIcon />
        </IconButton>
        {/* <Divider orientation="vertical" variant="middle" flexItem /> */}
        <IconButton
          color="inherit"
          LinkComponent={Link}
          target="_blank"
          href="https://sma2lbao.github.io/blog/"
        >
          <BookIcon />
        </IconButton>
      </Box>
    </FooterRoot>
  );
};

export default Footer;
